import React, { useState } from "react";
import { HexColorPicker } from "react-colorful";

const ThemeSetting = () => {
  // State to hold the color values
  const [colors, setColors] = useState({
    sidebarColor: "#2e4052",
    contentBg: "#eff6ef",
    iconColor: "#CAC6EA",
    viewIconColor: "#006ba6",
  });

  // Update CSS variables dynamically
  const handleColorChange = (key, color) => {
    setColors((prev) => ({ ...prev, [key]: color }));
    document.documentElement.style.setProperty(`--${key}`, color);
  };

  return (
      <>
          <div style={{ padding: "20px" }}>
              <h1 className="text-2xl font-bold mb-4">Dynamic Color Picker</h1>

              <div className="mb-4">
                  <h2 className="font-semibold">Sidebar Color:</h2>
                  <HexColorPicker
                      color={colors.sidebarColor}
                      onChange={(color) => handleColorChange("sidebar-color", color)}
                  />
                  <p className="mt-2">Selected Color: {colors.sidebarColor}</p>
              </div>

              <div className="mb-4">
                  <h2 className="font-semibold">Content Background:</h2>
                  <HexColorPicker
                      color={colors.contentBg}
                      onChange={(color) => handleColorChange("content-bg", color)}
                  />
                  <p className="mt-2">Selected Color: {colors.contentBg}</p>
              </div>

              <div className="mb-4">
                  <h2 className="font-semibold">Icon Color:</h2>
                  <HexColorPicker
                      color={colors.iconColor}
                      onChange={(color) => handleColorChange("icon-color", color)}
                  />
                  <p className="mt-2">Selected Color: {colors.iconColor}</p>
              </div>

              <div className="mb-4">
                  <h2 className="font-semibold">View Icon Color:</h2>
                  <HexColorPicker
                      color={colors.viewIconColor}
                      onChange={(color) => handleColorChange("view-icon-color", color)}
                  />
                  <p className="mt-2">Selected Color: {colors.viewIconColor}</p>
              </div>

          </div>
           <div className="flex flex-wrap gap-3">
              <div className="rounded-full bg-sidebar-color drop-shadow-lg ring-4 ring-slate-500  w-16 h-16"></div>
              <div className="rounded-full bg-icon-color drop-shadow-lg ring-4  ring-slate-500  w-16 h-16"></div>
              <div className="rounded-full bg-content-bg drop-shadow-lg ring-4 ring-slate-500  w-16 h-16"></div>
          </div>

      </>
  );
};

export default ThemeSetting;
